// extracted by mini-css-extract-plugin
module.exports = {"List":"List_List__1rWwe","inline":"List_inline__1GvmA","unstyled":"List_unstyled__2YyA5"};